import { ComplexContentModel } from '@eag/sales-app-base/build/app/core/rest-api/model/complex-content-model';
import { classNames } from 'primereact/utils';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { parseIdFromYoutubeVideoUrl } from 'utils/urlUtils';

interface Props {
	content: ComplexContentModel;
	className: string;
}

function MultipleVideosComponent(props: Props) {
	const { content, className } = props;

	return (
		<section className={classNames('login-page-content', className)}>
			<div className={'content-block col-12'}>
				<h6>{content.header}</h6>
				{content.body && <div dangerouslySetInnerHTML={{ __html: content.body }} />}
				{content.children?.length && (
					<Swiper modules={[Navigation]} className="swiper-container" spaceBetween={16} slidesPerView="auto" navigation>
						{content.children.map((video, index) => {
							const videoId = parseIdFromYoutubeVideoUrl(video.mediaUrl!);

							return (
								<SwiperSlide key={index}>
									<img src={`https://img.youtube.com/vi/${videoId}/default.jpg`} alt={content.header} />
									<div className="text-block">
										<div className="title">{video.header}</div>
										<div className="description">{video.body}</div>
									</div>
									<div className="play-button-wrapper">
										<a href={video.mediaUrl}>
											<span>{video.header}</span>
										</a>
									</div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				)}
			</div>
		</section>
	);
}

export default MultipleVideosComponent;
